import React from "react";
import { Link } from "react-router-dom";

const Header = (props) => {

  
  // Helper function to get proper avatar URL
  const getAvatarUrl = (userData) => {
    if (!userData || !userData.images) {
      return "/images/profile.png";
    }
    
    let imageUrl = userData.images;
    
    // Handle Google profile images - use them as-is
    // Google's format (=s96-c) works perfectly, don't modify
    
    // Check if it's a valid URL
    if (imageUrl.startsWith('blob:') || imageUrl.startsWith('http')) {
      return imageUrl;
    }
    
    return "/images/profile.png";
  };
  
  return (
    <>
      <div className="topHd">
        <div className="rightpane">
          <div className="row">
            <div className="col-5 col-lg-2">
              <button className="btn d-md-none mbutton" type="button" data-bs-toggle="offcanvas" data-bs-target="#demo">
                <i className='fa fa-bars'></i>
              </button>
              <Link to="/"> <img src="\images\logo.png" width={'100'} alt="" /></Link>
            </div>
            <div className='col-7 col-lg-10 text-end'>
              <div className="ms-auto">
                <ul className="navbar-nav">
                  <li className="nav-item">
                    <div className="input-group">
                      <input type="text" className="form-control searchbx" placeholder="Search" />
                      <div className="input-group-append">
                        <button className="btn-search" type="submit"><i className="fa fa-search"></i></button>
                      </div>
                    </div>
                  </li>
                  <li className="nav-item d-flex align-items-center ms-lg-3">
                    <div className="user-info d-none d-lg-block me-3">
                      <div className="pname">{(props.userData) ? (props.userData.first_name || props.userData.name?.split(' ')[0] || props.userData.name) : ''}</div>
                    </div>
                    <span className="prfdv">
                      <img 
                        src={getAvatarUrl(props.userData)} 
                        width={'40'} 
                        height={'40'} 
                        style={{borderRadius: '50%', objectFit: 'cover'}} 
                        alt='' 
                        onError={(e) => {
                          // Fallback to default profile image on error
                          e.target.src = "/images/profile.png";
                        }}
                      />
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>

  )
};

export default Header;